export const EVENTS = "/api/folders/:param/events"
export const EVENT = "/api/event/:eventParam"
export const CLOSE_EVENT = "/api/event/:eventParam/close"
export const EXPORT_EVENT = "/api/events/export"
